import React from 'react';
import PreBookingInfoAlert from '../components/PreBookingInfoAlert';
import BookApprovalInfoAlert from './BookApprovalInfoAlert';

const InPersonAlerts: React.FC = () => (
    <div>
      <BookApprovalInfoAlert />
      <PreBookingInfoAlert />
    </div>
  );

export default InPersonAlerts;
